export default __webpack_public_path__ + "static/media/cwpos-blue.8aa8eef1.png";